import styled from "styled-components";
import { colors } from "../../style/variables";

export const StrongNumber = styled.span`
    display:block;
    font-size:22px;
    font-weight:bold;
    color: ${colors.darkGreyEgg}
`